import { createStore } from '@ngneat/elf';
import { withEntities } from '@ngneat/elf-entities';
import {
  Arrangement,
  Method,
  ResourceWithMethodSlug,
  Resource,
  Group,
} from '@thiememeulenhoff/types';

export const arrangements = createStore(
  { name: 'arrangements' },
  withEntities<Arrangement, 'code'>({
    idKey: 'code',
  }),
);

export const arrangementTemplates = createStore(
  { name: 'arrangementTemplates' },
  withEntities<Arrangement, 'code'>({
    idKey: 'code',
  }),
);

export const methods = createStore(
  { name: 'methods' },
  withEntities<Method, 'slug'>({
    idKey: 'slug',
  }),
);

export const resources = createStore(
  { name: 'resources' },
  withEntities<ResourceWithMethodSlug, 'contentIdentifier'>({
    idKey: 'contentIdentifier',
  }),
);

export const resourcesInArrangement = createStore(
  { name: 'resources' },
  withEntities<Resource, 'contentIdentifier'>({
    idKey: 'contentIdentifier',
  }),
);

export const groups = createStore(
  { name: 'groups' },
  withEntities<Group, 'id'>({
    idKey: 'id',
  }),
);
